<template>
  <div class="productItemBox" @click="toProductsDetail(item)">
    <div class="productItem" >
      <div class="itemImgBox">
        <img :src="httpUrl+'/'+item.productImg" alt="">
        <div v-show="!item.isCollect" @click="addCollect(item)" class="productColl">
          <img src="@/assets/fonts/Love.svg" alt="">
        </div>
        <div v-show="item.isCollect" @click="delCollect(item)" class="productColl">
          <img src="@/assets/fonts/showLove.svg" alt="">
        </div>
      </div>
      <div class="productItemTitle">{{ item.productName }}</div>
      <div class="productItemPrice">
        <div>${{ item.productShowPrice }}</div>
        <div>
          <div  @click="toProductsDetail(item)"  class="productIcon">
            <img src="@/assets/fonts/bag.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_API } from '@/assets/js/conSysUrl';
import { AddCollect, DeleteCollect } from '@/api/collect';
export default {
  // props: ['item', 'isCollect', 'fetch-data'],
  props: {
    item: {
      type: Object,
      default: () => ({})
    }, 
    'fetch-data': {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      httpUrl: HTTP_API,
    }
  },
  methods: {
    toProductsDetail(item) {
      event.stopPropagation();
      const route = this.$router.resolve({ path: `/productDetail`,query:{ id: item.id} });
      window.open(route.href, '_blank');
      // this.$router.push({
      //   name: 'productDetail',
      //   query: {
      //     id: item.id
      //   }
      // })
    },
    async addCollect(item) { 
      event.stopPropagation();
      if (!this.$store.state.user) { 
        this.$EventBus.$emit('showLogin');
        // this.$message.error('Please login first');
        return
      }
      try {
        const msg = {
          userId: this.$store.state.user.id,
          productId: item.id
        }
        const { status } = await AddCollect(this.$store.state.user.id,msg)
        if (status) { 
          this.$emit('fetch-data');
          this.$message.success('Successful collection');
        } 
      } catch (error) {
        
      }
    },
    async delCollect(item) { 
      event.stopPropagation();
      if (!this.$store.state.user) { 
        this.$EventBus.$emit('showLogin');
        this.$message.error('Please login first');
        return
      }
      try {
        const msg = {
          userId: this.$store.state.user.id,
          productId: item.id,
          id: item.collectId
        }
        const { status } = await DeleteCollect(this.$store.state.user.id,msg)
        if (status) {
          this.$message.success('Cancel collection successfully');
          this.$emit('fetch-data');
        } 
      } catch (error) {
        
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .productItemBox{
    // display: flex;
    // flex-wrap: wrap;
    height: 80%;
    width: 100%;
    .productItem{
      background: #e8e8e8;
      margin: 15px 5px 0;
      border-radius: 1px;
      box-shadow: 0 0 5px 0 rgba(0,0,0,0.1);
      overflow: hidden;
      // width: 200px;
      cursor: pointer;
      position: relative;
      .itemImgBox{
        min-height: 150px;
        // height: 190px;
        >img{
          min-height: 145px;
          // padding: 8px;
          width: 100%;
        }
        >img:hover{
          transition: all 0.3s;
          transform: scale(1.05);
        }
        .productColl{
          position: absolute;
          top: 5px;
          right: 5px;
          // background: #918472;
          >img{
            width: 25px;
          }
          >img:hover{
            transform: scale(1.2);
            transition: all 0.3s;

          }
        }
      }

      .productItemTitle{
        // color: #bead95;
        font-weight: 600;
        padding: 10px 5px 3px 5px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 46px;
        // text-align: center;
      }
      .productItemPrice{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        >div:nth-child(1){
          color: #f8b010;
          font-size: 20px;
          font-weight: 600;
          font-family: '黑体';
        }
        >div:nth-child(2){
          display: flex;
          .productIcon{
            // width: 40px;
            // height: 26px;
            // position: relative;
            // margin-right: 5px;
            // background: #f1dcbe;
            // border-radius: 5px;
            // box-shadow:  0 0 10px 0 rgba(0,0,0,0.1);
            >img{
              // position: absolute;
              // top: 50%;
              // left: 50%;
              // transform: translate(-50%,-50%);
              width: 18px;
            }
          }
          .productIcon:hover{
            // background: #918472;
            >img{
              transform: scale(1.2);
              transition: all 0.3s;
            
            }

          }
        }
      }
    }
  }
</style>